import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const STATUS_COPY = {
  PAID: {
    icon: 'CheckCircle2',
    tone: 'text-success',
    title: 'Pagamento aprovado',
    message: 'Seu cartão foi aprovado. A licença será liberada em instantes.',
  },
  WAITING: {
    icon: 'Clock',
    tone: 'text-yellow-600',
    title: 'Pagamento em análise',
    message: 'Seu pagamento está sendo processado. Acompanhe em Minhas compras.',
  },
  DECLINED: {
    icon: 'XCircle',
    tone: 'text-destructive',
    title: 'Pagamento recusado',
    message: 'O cartão não foi aprovado. Tente outro cartão ou forma de pagamento.',
  },
};

const CardPaymentResultPanel = ({ result, onClose }) => {
  const copy = STATUS_COPY[result?.status] || STATUS_COPY.WAITING;

  return (
    <div className="space-y-4">
      <div className="rounded-lg border border-border bg-muted/20 p-4 flex gap-3">
        <Icon name={copy.icon} size={22} className={`${copy.tone} flex-shrink-0 mt-0.5`} />
        <div className="space-y-1">
          <p className="text-sm font-medium text-foreground">{copy.title}</p>
          <p className="text-xs text-muted-foreground">{copy.message}</p>
          {result?.payment_id && (
            <p className="text-xs text-muted-foreground">ID: {result.payment_id}</p>
          )}
        </div>
      </div>
      <Button fullWidth onClick={onClose}>
        Voltar para a loja
      </Button>
    </div>
  );
};

export default CardPaymentResultPanel;
